import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, } from "@angular/material";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-set-edu-student-course',
  templateUrl: './set-edu-student-course.component.html',
  styleUrls: ['./set-edu-student-course.component.css']
})
export class SetEduStudentCourseComponent implements OnInit {

  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'function',
    'name',
    "nationalCode",
    'price',
    'priceFinal'
  ];
  constructor(
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private registrationService: RegistrationService,
    private dialogRef: MatDialogRef<SetEduStudentCourseComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.dataSource = this.data.studentList.filter(function (element) {
      return element.RegistrationStatusId == 121;
    });
  }
  setEdu(id: number, isEdu: boolean) {
    this.errors = new Array();
    var model = {
      Id: id,
      IsEduOrg: isEdu
    }
    this.registrationService.setEduOrg(model).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          'وضعیت با موفقیت تغییر کرد',
          "ok",
          5000,
          SoundEnum.beep
        );
        //this.dialogRef.close(model);
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


}
